// store/college/progress-tracking/_actions.js

import * as actionTypes from './_actionTypes';

/**
 * Fetch all students progress
 */
export const fetchStudentProgressRequest = (filters = {}) => ({
  type: actionTypes.FETCH_STUDENT_PROGRESS_REQUEST,
  payload: filters,
});

export const fetchStudentProgressSuccess = (data) => ({
  type: actionTypes.FETCH_STUDENT_PROGRESS_SUCCESS,
  payload: data,
});

export const fetchStudentProgressFailure = (error) => ({
  type: actionTypes.FETCH_STUDENT_PROGRESS_FAILURE,
  payload: error,
});

/**
 * Fetch single student progress
 */
export const fetchSingleStudentProgressRequest = (studentId) => ({
  type: actionTypes.FETCH_SINGLE_STUDENT_PROGRESS_REQUEST,
  payload: studentId,
});

export const fetchSingleStudentProgressSuccess = (data) => ({
  type: actionTypes.FETCH_SINGLE_STUDENT_PROGRESS_SUCCESS,
  payload: data,
});

export const fetchSingleStudentProgressFailure = (error) => ({
  type: actionTypes.FETCH_SINGLE_STUDENT_PROGRESS_FAILURE,
  payload: error,
});

/**
 * Export progress report
 */
export const exportProgressReportRequest = (filters = {}, format = 'json') => ({
  type: actionTypes.EXPORT_PROGRESS_REPORT_REQUEST,
  payload: { filters, format },
});

export const exportProgressReportSuccess = () => ({
  type: actionTypes.EXPORT_PROGRESS_REPORT_SUCCESS,
});

export const exportProgressReportFailure = (error) => ({
  type: actionTypes.EXPORT_PROGRESS_REPORT_FAILURE,
  payload: error,
});

/**
 * Set and clear filters
 */
export const setProgressFilters = (filters) => ({
  type: actionTypes.SET_PROGRESS_FILTERS,
  payload: filters,
});

export const clearProgressFilters = () => ({
  type: actionTypes.CLEAR_PROGRESS_FILTERS,
});

/**
 * Set and clear selected student
 */
export const setSelectedStudent = (student) => ({
  type: actionTypes.SET_SELECTED_STUDENT,
  payload: student,
});

export const clearSelectedStudent = () => ({
  type: actionTypes.CLEAR_SELECTED_STUDENT,
});